// extracted by mini-css-extract-plugin
export default {"logo":"About_logo__D3Hnn"};